export const decodeBase64 = (encryptedData: string) => {
  return atob(encryptedData)
}
export const encodeBase64 = (data: string) => {
  return btoa(data)
}
